<script lang="ts">
  import { RICH_TOOLTIP_CLASS, tooltip } from "@kontextwerk/web-sdk/core/overlay/tooltip"
  import { escapeHtml } from "@kontextwerk/web-sdk/core/security"
  import SourceCleanupInstructionTags from "../../../../../../../../_shared/_modules/source-cleanup-instruction-tags"
  import type {
    SourceCleanupInstructionPresentation,
    SourceCleanupTooltipField,
  } from "../../../../../../../../_shared/_logic/source-cleanup-instruction-tags"

  let {
    instructions = [],
    note = "",
    disabled = false,
  }: {
    instructions?: SourceCleanupInstructionPresentation[]
    note?: string
    disabled?: boolean
  } = $props()

  const normalizedNote = $derived(note.trim())
  const tooltipContext = $derived<SourceCleanupTooltipField[]>(
    normalizedNote ? [{ label: "Kundenaussage", value: normalizedNote }] : [],
  )
</script>

<span class="wrong-recipient-source-instructions" class:disabled>
  <SourceCleanupInstructionTags {instructions} context={tooltipContext} />
  {#if normalizedNote}
    <span
      class="wrong-recipient-source-instructions__note"
      use:tooltip={{ content: escapeHtml(normalizedNote), className: RICH_TOOLTIP_CLASS }}
    >
      Kundenaussage: {normalizedNote}
    </span>
  {/if}
</span>

<style>
  .wrong-recipient-source-instructions {
    display: inline-flex;
    flex-direction: column;
    gap: 0.24rem;
    max-width: 100%;
  }

  .wrong-recipient-source-instructions.disabled {
    opacity: 0.54;
  }

  .wrong-recipient-source-instructions__note {
    color: var(--text-invers-100);
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    line-height: 1.28;
    max-width: 42rem;
    white-space: normal;
  }
</style>
